<template>
    <button
        @click="$emit('click')"
        :class="{ 'btn-primary': !transparent, 'btn-link': transparent }"
        :disabled="disabled"
        class="btn"
    >
        <slot v-if="!loading" />
        <ClipLoader :loading="loading" color="#FFF" />
    </button>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader';

export default {
	components: {
		ClipLoader
	},

	props: {
		transparent: Boolean,
		loading: Boolean,
		disabled: Boolean
	}
};
</script>

<style lang="scss" scoped>
.v-spinner {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 36px !important;
}

.btn {
	font-weight: 500;
	font-size: 20px;
	min-width: 100%;
	line-height: 2;
	border-radius: 8px;

	&:focus {
		outline: 0;
		box-shadow: none;
	}
}

.btn.disabled,
.btn:disabled {
	opacity: 1;
	background: #C5CED7;
}

.btn-primary {
	border: none;
	background: #0774E7;

	&:not(:disabled):not(.disabled):active,
	&:not(:disabled):not(.disabled).active {
		background-color: #0774E7;
		border-color: #0774E7;
	}

	&:not(:disabled):not(.disabled):active:focus,
	&:not(:disabled):not(.disabled).active:focus {
		box-shadow: none;
	}
}

.btn-link {
	border: none;
	color: #0774E7;
	background-color: transparent;

	&:not(:disabled):not(.disabled):active,
	&:not(:disabled):not(.disabled).active {
		background-color: #F2F4F8;
		border: 1px solid #6D7783;
	}

	&:not(:disabled):not(.disabled):active:focus,
	&:not(:disabled):not(.disabled).active:focus {
		box-shadow: none;
	}
}

.btn-success {
	border: none;
	background: #009E55;

	&:not(:disabled):not(.disabled):active,
	&:not(:disabled):not(.disabled).active {
		background-color: #009E55;
		border-color: #009E55;
	}

	&:not(:disabled):not(.disabled):active:focus,
	&:not(:disabled):not(.disabled).active:focus {
		box-shadow: none;
	}
}
</style>
